import hasDom from 'has-dom';
import { injectScript } from '@atc/dom-fns';
import { waitUntil } from '@atc/wait-until';
import { getGoogleConfiguration } from './googleConfiguration';
let gtmLoaded = false;
let isPageTagSent = false;
let removePageExitListener = () => {};
function resetIsPageTagSent() {
  isPageTagSent = false;
}
export default async function ensureGoogleAnalytics(options, callback, _temp) {
  let {
    history = {},
    isPageEvent = false
  } = _temp === void 0 ? {} : _temp;
  const {
    initialConfig = {},
    disableGTM = false,
    disableGTMEvents = true,
    skipPageEvent = false
  } = options;
  const {
    gtmPath = '//www.googletagmanager.com/gtm.js',
    usePartyTown = false,
    delay = 0
  } = getGoogleConfiguration();

  // GA is currently a client-only solution so ensure we only process on the client
  // abort if we are on the server or if GTM is disabled
  if (disableGTM || !hasDom()) {
    return;
  }
  const gtmContainerCode = initialConfig?.google?.gtmCode || '';
  const dynamicDataLayer = initialConfig?.google?.dataLayerName;
  if (!gtmLoaded && gtmContainerCode) {
    gtmLoaded = new Promise(resolve => {
      if (dynamicDataLayer) {
        window[dynamicDataLayer] = window[dynamicDataLayer] || [];
        window[dynamicDataLayer].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
      if (dynamicDataLayer) {
        window[dynamicDataLayer] = window.dataLayer || [];
      }

      // if window.dataLayer is returned instead of resolve(true), the analytics:pageReady event won't fire
      injectScript(`${gtmPath}?id=${gtmContainerCode}`, {
        elementAttributes: {
          type: usePartyTown ? 'text/partytown' : 'text/javascript'
        },
        delay
      }).then(() => {
        if (usePartyTown) {
          window.dispatchEvent(new CustomEvent('ptupdate'));
        }
        resolve(true);
      });
    });
  }

  // eslint-disable-next-line consistent-return
  const sendEvent = () => {
    if (typeof callback === 'function' && !disableGTMEvents) {
      return setTimeout(() => callback(window.dataLayer), 0);
    }
  };
  try {
    if (isPageEvent) {
      removePageExitListener();
      isPageTagSent = true;

      // legacy support
      if (history.listen) {
        removePageExitListener = history.listen(resetIsPageTagSent);
      }

      // eventListener support
      if (history.eventListener) {
        const {
          on = () => {},
          off = () => {},
          pageExitEvent = ''
        } = history.eventListener;
        on(pageExitEvent, resetIsPageTagSent);
        removePageExitListener = () => {
          off(pageExitEvent, resetIsPageTagSent);
        };
      }
      sendEvent();
    } else {
      waitUntil(() => isPageTagSent || skipPageEvent, () => {
        sendEvent();
      }, 30, 15000);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('GA360: Failed to Send Event: ', error);
    window.newrelic.noticeError('GA360: Failed to Send Event ' + error);
  }
}